<template>
  <ProjectFeature
    class="a250-feature"
    left-background-image="/assets/a250/a250-content-bg.jpg"
    right-background-color="#003366"
  >
    <template #left-header>
      <div class="feature-logo">
        <h2>
          Powering the America 250
          <br />
          Livestream Experience
        </h2>
      </div>
    </template>

    <template #left-body>
      <div class="feature-list">
        <p>Zenapptic is proud to have powered the digital experience behind the official America 250 livestream platform, bringing together live programming from celebrations across the United States .</p>
        <p>Orchestrated multiple scheduled livestreams, real-time content, and dynamic web experiences through a single centralized platform for viewers across the country - over 3 days of celebrations!</p>
      </div>
    </template>

    <template #left-footer>
      <div class="a250-logo">
        <img src="/assets/a250/a250-logo.png" alt="America 250 Logo" />
      </div>
    </template>

    <template #right-media>
      <div class="video-container">
        <ProjectFeatureMedia
          class="a250-video-player"
          :video-url="`${useCdnUrl()}/assets/a250/a250-preview.webm`"
          placeholder-text="Watch the video"
          :poster="`${useCdnUrl()}/assets/a250/a250-video-panel.jpg`"
        >
          <img class="video-preview" :src="`${useCdnUrl()}/assets/a250/a250-video-panel.jpg`" alt="America 250 livestream experience video preview" />
        </ProjectFeatureMedia>
      </div>
    </template>
  </ProjectFeature>
</template>

<style lang="scss">
.a250-feature {
  .project-feature__left {
    gap: 3rem;
    justify-content: space-between;
    padding-top: 2rem;

    &::after {
      background: linear-gradient(to right, #3250ff 0 5px, #ffffff 5px 10px, #f90000 10px 15px);
      bottom: 0;
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 15px;
    }

    @media (max-width: 1024px) {
      padding-bottom: 5rem;
    }

    @media (max-width: 767px) {
      gap: 1rem;
    }
  }

  .project-feature__right {
    @media (max-width: 1024px) {
      overflow: visible;
    }
  }

  .feature-logo {
    padding: 5rem 0 0;

    @media (max-width: 767px) {
      padding: 2rem 0 0;
    }

    h2 {
      color: black;
      font-family: 'DM Serif Text', Georgia, serif;
      font-size: 6.5rem;
      font-weight: 400;
      letter-spacing: -0.03em;
      line-height: 1;
      margin: 0;
    }
  }

  .feature-list {
    @media (max-width: 767px) {
      padding: 2rem 0;
    }

    p {
      color: black;
    }
  }

  .a250-logo {
    text-align: center;
  }

  .video-container {
    flex: 1 1 auto;
    max-width: 100%;
    min-height: 0;
    position: relative;

    .a250-video-player,
    .video-placeholder {
      height: 100%;
      max-width: none;
    }

    .a250-video-player {
      width: 100%;
    }

    .video-placeholder {
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      display: flex;
      font-weight: 700;
      justify-content: center;
      overflow: hidden;
      width: 100%;
    }

    .video-preview {
      display: block;
      height: 100%;
      min-height: 0;
      object-fit: cover;
      pointer-events: none;
      width: 100%;
    }
  }
}
</style>
